<template>
    <div id="extra-component-form-validation-demo">
        <ProfileForm />

        <PasswordForm />
    </div>
</template>

<script>

    import ProfileForm from "./profile/ProfileForm";
    import PasswordForm from "./profile/PasswordForm";
    export default {
        components: {
            PasswordForm,
            ProfileForm

        }
    }
</script>
